/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Waffo_Tax_CategoryInputs */

const en_admin_settings_fields_waffo_tax_category = /** @type {(inputs: Admin_Settings_Fields_Waffo_Tax_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax category`)
};

/**
* | output |
* | --- |
* | "Tax category" |
*
* @param {Admin_Settings_Fields_Waffo_Tax_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_waffo_tax_category = /** @type {((inputs?: Admin_Settings_Fields_Waffo_Tax_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Waffo_Tax_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_waffo_tax_category(inputs)
});
export { admin_settings_fields_waffo_tax_category as "admin.settings.fields.waffo_tax_category" }